<template>
  <!--  -->
  <div>
    <!--  -->
    <filter-bar name="groups" :filters="filters" @reset="resetData" @filtrer="filterData" @search="search" @searchRoles="searchRoles"></filter-bar>
    <!--  -->

    <!--  -->
    <div class="min-h-screen flex-1 bg-gray-100 px-3 items-center">
      <!--  -->
      <div class="bg-white w-fullrounded-lg shadow overflow-hidden">
        <!--  -->
        <div class="h-20 py-3 flex items-center border-gray-200 p-6">
          <!--  -->
          <div class="flex">
            <!--  -->
            <div class="text-2xl font-bold text-primary-700">
              {{ $t('groups') }}
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="w-full flex justify-end">
            <!--  -->
            <router-link
              class="flex rounded focus:outline-none outline-none text-white px-3 w-1/7 py-2 bg-primary-600 hover:shadow-inner ml-4 hover:bg-primary-600 transition-all duration-300"
              to="/groups/new">
              <!--  -->
              <i class="material-icons">add</i> {{ $t('add_group') }}
              <!--  -->
            </router-link>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="overflow-x-auto">
          <!--  -->
          <base-table :refresh="refresh" :content="content" :headers="headers" name="groups">
            <!--  -->
          </base-table>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="p-1">
          <!--  -->
          <div class="flex flex-col items-center my-12" :class="paginate.lastpage">
            <!--  -->
            <div v-if="paginate.lastpage > 1" class="flex text-gray-700">
              <!--  -->
              <button v-if="paginate.currentpage > 1" @click="prev" :disabled="paginate.currentpage == 1"
                class="h-8 w-8 focus:outline-none mr-6 flex justify-center text-primary-700 items-center rounded-full bg-gray-200 hover:bg-primary-600 hover:text-white cursor-pointer">
                <!--  -->
                <i class="material-icons"> keyboard_arrow_left </i>
                <!--  -->
              </button>
              <!--  -->

              <!--  -->
              <div class="flex h-8 font-medium rounded-full bg-gray-200">
                <!--  -->
                <div v-if="paginate.currentpage != paginate.lastpage"
                  class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full bg-primary-600 text-white">
                  {{ paginate.currentpage }}
                </div>
                <!--  -->

                <!--  -->
                <div v-else class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full">
                  <!--  -->
                  <span v-if="paginate.currentpage != 1"> 1 </span>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div v-if="paginate.currentpage >= 1 && paginate.lastpage != 1" class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full">
                  ...
                </div>
                <!--  -->

                <!--  -->
                <button :class="paginate.currentpage == paginate.lastpage ? 'bg-primary-600  text-white' : ' ' " class="w-8 md:flex justify-center items-center hover:bg-primary-600 hover:text-white focus:outline-none hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full">
                  {{ paginate.lastpage }}
                </button>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <button v-if="paginate.currentpage < paginate.lastpage" :disabled="paginate.currentpage == paginate.lastpage" @click="next" class="h-8 w-8 ml-6 focus:outline-none flex justify-center text-primary-700 items-center rounded-full bg-gray-200 hover:bg-primary-600 hover:text-white cursor-pointer">
                <!--  -->
                <i class="material-icons"> keyboard_arrow_right </i>
                <!--  -->
              </button>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  data() {
    return {
      content: [],
      headers: ['fullName', 'phone', 'email', 'role', 'countries', 'status'],
      groups: [],
      statusUser: ['active', 'inactive', 'blocked', 'deleted'],
      typeUser: [],
      limit: 10,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      filter: {},
      barFilters: {},
      warehouses: [],
      idWarehouse: null,
      filters: {
        name: 'groups',
        elements: {
          search: {
            options: {
              icon: 'search',
              label: 'search',
              class: '',
              hint: 'FullName, username, phone, email ...',
            },
            value: null,
            type: 'search',
            validate: {
              trim: true,
              required: false,
              minlength: 0,
            },
          },
          champs: [
            {
              label: 'Role',
              key: 'role',
              name: 'name',
              value: null,
              values: [],
              class:
                'py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white',
              type: 'select',
            },
            {
              label: 'Status',
              key: 'status',
              value: null,
              values: [],
              class:
                'py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white',
              type: 'select',
            },
          ],
        },
      },
    };
  },
  async mounted() {
    this.barFilters = this.$f.QueryStringToobject() || { limit: this.limit };

    await this.fetchWarehouseId();

    if (this.barFilters.name) {
      await this.search(this.barFilters.name);
    } else {
      await this.fetchUsers(this.barFilters);
    }

    await this.fetchRoles();
    this.setSelectData('role', this.typeUser);
    this.setSelectData('status', this.statusUser);
  },
  computed: {
    warehouseSelected() {
      return this.$store.getters['warehouse/warehouseSelected'];
    },
  },
  watch: {
    warehouseSelected: {
      immediate: true,
      async handler() {
        await this.fetchWarehouseId();
        await this.resetData();
      },
    },
  },
  methods: {
    async fetchWarehouseId() {
      try {
        const warehouseId = await this.$store.dispatch('wharhouse/getwharhouseId');
        this.idWarehouse = warehouseId;
      } catch (error) {
        console.error('Failed to fetch warehouse ID:', error);
      }
    },
    setSelectData(model, data, splice = false) {
      const { champs } = this.filters.elements;

      const targetIndex = champs.findIndex(
        (champ) => champ.type === 'select' && champ.key === model
      );

      if (targetIndex !== -1) {
        if (!splice) {
          champs[targetIndex].values = data;
        } else {
          champs.splice(targetIndex, 1);
        }
      }
    },
    async getWarehouses() {
      try {
        const filter = { limit: 1000, is_primary: true };
        const { content } = await this.$server.search('warehouses', filter);

        this.warehouses = content.results || [];
      } catch (error) {
        console.error('Failed to fetch warehouses:', error);
        this.warehouses = [];
      }
    },
    getElementInArray(data, value, table) {
      return data.find((item) => {
        const id = table === 'warehouses'
          ? item._id.toString()
          : item.warehouse.toString() || '';

        return id === value.toString();
      }) || null;
    },
    async fetchUsers(filters) {
      try {
        filters.countries = await this.warhouseSelected;

        const { content } = await this.$server.search('groups', filters);

        if (content.results) {
          this.content = content.results;
          const pagination = content.pagination;
          this.paginate = {
            total: pagination.total,
            lastpage: pagination.last_page,
            per_page: pagination.per_page,
            currentpage: pagination.current_page,
          };

          this.content = this.content.map((item) => ({
            ...item,
            countries: item.countries.map((country) =>
              country ? this.$f.getCountryCode(country) : country
            ),
          }));
        } else {
          this.content = [];
          this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
        }
      } catch (error) {
        console.error('Failed to fetch users:', error);
        this.content = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async search(data) {
      try {
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };

        const limit = this.filters.limit ? this.barFilters.limit : this.limit;

        const search = {
          name: data.trim(),
          limit: parseInt(limit),
          countries: await this.warhouseSelected,
        };

        this.$f.objectToQueryString(search);

        const { content } = await this.$server.find('groups', search);

        if (content.results && content.results.length > 0) {
          this.content = content.results.map((item) => ({
            ...item,
            countries: item.countries.map((country) =>
              country ? this.$f.getCountryCode(country) : country
            ),
          }));

          const pagination = content.pagination;
          this.paginate = {
            total: pagination.total,
            lastpage: pagination.last_page,
            per_page: pagination.per_page,
            currentpage: pagination.current_page,
          };
        } else {
          this.content = [];
        }
      } catch (error) {
        console.error('Failed to perform search:', error);
        this.content = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async filterData(data) {
      try {
        this.barFilters = this.$f.QueryStringToobject() || {};

        const { page, name, ...restFilters } = this.barFilters;
        this.barFilters = restFilters;

        if (!this.barFilters.limit) {
          this.barFilters.limit = this.limit;
        }

        if (data.role) {
          this.barFilters.role = data.role._id;
        } else {
          delete this.barFilters.role;
        }

        if (data.status) {
          this.barFilters.status = data.status;
        } else {
          delete this.barFilters.status;
        }

        this.paginate.currentpage = 1;
        this.$f.objectToQueryString(this.barFilters);

        await this.fetchUsers(this.barFilters);
      } catch (error) {
        console.error('Failed to filter data:', error);
      }
    },
    async refresh() {
      try {
        this.barFilters = this.$f.QueryStringToobject() || {};

        this.$f.objectToQueryString(this.barFilters);

        if (this.barFilters.name) {
          await this.search(this.barFilters.name);
        } else {
          await this.fetchUsers(this.barFilters);
        }

        if (
          this.barFilters.page > 1 &&
          this.content.length === 0
        ) {
          this.barFilters.page--;
          this.$f.objectToQueryString(this.barFilters);
          await this.fetchUsers(this.barFilters);
        }
      } catch (error) {
        console.error('Failed to refresh data:', error);
      }
    },
    async resetData() {
      try {
        this.barFilters = this.$f.QueryStringToobject() || {};

        const limit = this.barFilters.limit || this.limit;

        this.barFilters.page = 1;
        this.$f.objectToQueryString({ limit });

        await this.fetchUsers({ limit });
      } catch (error) {
        console.error('Failed to reset data:', error);
      }
    },
    async next() {
      try {
        this.barFilters = this.$f.QueryStringToobject() || {};

        this.barFilters.page = ++this.paginate.currentpage;
        this.$f.objectToQueryString(this.barFilters);

        await this.fetchUsers(this.barFilters);
      } catch (error) {
        console.error('Failed to navigate to the next page:', error);
      }
    },
    async prev() {
      try {
        this.barFilters = this.$f.QueryStringToobject() || {};

        this.barFilters.page = --this.paginate.currentpage;
        this.$f.objectToQueryString(this.barFilters);

        await this.fetchUsers(this.barFilters);
      } catch (error) {
        console.error('Failed to navigate to the previous page:', error);
      }
    },
    async fetchRoles() {
      try {
        const { content } = await this.$server.search('roles');
        this.typeUser = content.results || [];
      } catch (error) {
        console.error('Failed to fetch roles:', error);
        this.typeUser = [];
      }
    },
    searchRoles: _.debounce(async function(search) {
      try {
        const filter = {
          limit: 10,
          name: search,
        };

        const { content } = await this.$server.find('roles', filter);

        this.typeUser = content.results || [];
        this.setSelectData('role', this.typeUser, null);
      } catch (error) {
        console.error('Failed to search roles:', error);
        this.typeUser = [];
        this.setSelectData('role', this.typeUser, null);
      }
    }, 500)
  },
};
</script>